import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IEmptyResult } from '~src/httpClient/serverApi/types/IResponse';

export type DeleteLinkedTasksParams = {
  readonly ids: string[];
}

export class DeleteLinkedTasksRequest extends Request<DeleteLinkedTasksParams, IEmptyResult> {
  constructor(params: DeleteLinkedTasksParams) {
    super('deleteLinkedTasks', params);
  }
}
